import { defineMessages } from 'react-intl';

export const messages: {
	[key in
		| 'expandLabel'
		| 'metadataLabel'
		| 'pullRequestId'
		| 'reviewerCount'
		| 'lastUpdated'
		| 'statusOpen'
		| 'statusMerged'
		| 'statusDeclined'
		| 'statusDraft'
		| 'statusUnknown']: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	expandLabel: {
		id: 'search-page.linked-pull-requests.expand-label',
		defaultMessage:
			'{count}{hasMore, select, true {+} other {}} {count, plural, one {Pull request} other {Pull requests}}',
		description:
			'Label for the expand button showing the number of linked pull requests, with a + suffix when there may be more',
	},
	metadataLabel: {
		id: 'search-page.linked-pull-requests.metadata-label',
		defaultMessage: 'Pull Request',
		description: 'Label identifying the item type as a pull request',
	},
	pullRequestId: {
		id: 'search-page.linked-pull-requests.pull-request-id',
		defaultMessage: 'ID# {prId}',
		description: 'Pull request identifier label with the PR number',
	},
	reviewerCount: {
		id: 'search-page.linked-pull-requests.reviewer-count',
		defaultMessage: '{count, plural, =0 {No reviewers} one {# reviewer} other {# reviewers}}',
		description: 'Number of reviewers on the pull request',
	},
	lastUpdated: {
		id: 'search-page.linked-pull-requests.last-updated',
		defaultMessage: 'Updated {relativeTime}',
		description: 'Relative time since the pull request was last updated, e.g. "Updated 2 days ago"',
	},
	statusOpen: {
		id: 'search-page.linked-pull-requests.status-open',
		defaultMessage: 'Open',
		description: 'Status label for an open pull request',
	},
	statusMerged: {
		id: 'search-page.linked-pull-requests.status-merged',
		defaultMessage: 'Merged',
		description: 'Status label for a merged pull request',
	},
	statusDeclined: {
		id: 'search-page.linked-pull-requests.status-declined',
		defaultMessage: 'Declined',
		description: 'Status label for a declined pull request',
	},
	statusDraft: {
		id: 'search-page.linked-pull-requests.status-draft',
		defaultMessage: 'Draft',
		description: 'Status label for a draft pull request',
	},
	statusUnknown: {
		id: 'search-page.linked-pull-requests.status-unknown',
		defaultMessage: 'Unknown',
		description: 'Status label for a pull request with an unknown status',
	},
});
